import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const load = () => (cache ||= api.get("/models").then((r) => r.data.models || []).catch(() => { cache = null; return []; }));

// Shared model catalog (fetched once per page load).
export default function useModels(enabled = true) {
  const [models, setModels] = useState([]);
  useEffect(() => { if (enabled) load().then(setModels); }, [enabled]);
  return models;
}

const RES_ORDER = ["360p", "480p", "540p", "720p", "768p", "1080p", "1K", "1440p", "2K", "4K", "8K"];
export const maxRes = (m) => {
  const r = m?.capabilities?.resolutions || [];
  return r.length ? [...r].sort((a, b) => RES_ORDER.indexOf(a) - RES_ORDER.indexOf(b))[r.length - 1] : null;
};

export const fmtDims = (w, h) => (w && h ? `${w}×${h}` : null);
export const feedSpecs = (it) => [fmtDims(it.width, it.height), it.resolution, it.aspect_ratio && it.aspect_ratio !== "auto" ? it.aspect_ratio : null].filter(Boolean);
